import { Auth } from '@/database';
const state = {
	files: {tree: [], flat: {}} ,
	file: null,
	errors: [],
	fileTypes: [],
	loading: false,
};

const getters = {
	files: state => state.files,
	file: state => state.file,
	fileTypes: state => state.fileTypes,
	errors: state => state.errors,
	filesLoading: state => state.loading,
};

const actions = {
	async getFiles({commit}) {
		commit('setLoading', true);
		const db = new Auth();
		const response = await db.fetch('/files/list/');
		let files = await response.json();
		commit('setFiles', files);
		commit('setLoading', false);
	},
	async getFileTypes({commit}) {
		const db = new Auth();
		const response = await db.fetch('/files/filetypes/');
		const fileTypes = await response.json();
		commit('setFileTypes', fileTypes);
	},
	
	async uploadFile({commit, dispatch}, {path, files}) {
		commit('setLoading', true);
		const db = new Auth();
		// Prompts the user to select a file, returns a promise
		// Uploads the file to the server, returns a promise
		const formData = new FormData();
		formData.append('path', path);
		for (let i = 0; i < files.length; i++) {
			formData.append('files', files[i], files[i].name);
		}
		
		const response = await fetch(db.url + '/files/upload/',
		{
			method: 'POST',
			body: formData,
			headers: {
				'Authorization': `Bearer ${sessionStorage.getItem('token')}`
			}
		});
		const output = await response.json()
		output.filter(x => x.error).forEach(error => commit('addError', error));
		await dispatch('getFiles');
		commit('setLoading', false);
	},
	async makeDirectory({dispatch, commit}, path) {
		commit('setLoading', true);
		const db = new Auth();
		const response = await db.fetch('/files/mkdir/', {
			method: 'POST',
			body: JSON.stringify({path})
		});
		const output = await response.json()
		if (output.error) commit('addError', output);
		await dispatch('getFiles');
		commit('setLoading', false);
	},
	async deleteFile({dispatch, commit}, path) {
		commit('setLoading', true);
		const db = new Auth();
		const response = await db.fetch(`files/delete/`, {
			method: 'POST',
			body: JSON.stringify({path})
		});
		const output = await response.json()
		output.filter(x => x?.error).forEach(error => commit('addError', error));
		await dispatch('getFiles');
		commit('setLoading', false);
	},
	async modifyFile({dispatch, commit}, {path, file}) {
		commit('setLoading', true);
		const db = new Auth();
		const response = await db.fetch(`files/modify/`, {
			method: 'POST',
			body: JSON.stringify({path, metadata: file})
		});
		const output = await response.json()
		if (output.error) commit('addError', output);
		await dispatch('getFiles');
		commit('setLoading', false);
	},
	async moveFile({dispatch, commit}, {path, parent}) {
		commit('setLoading', true);
		const db = new Auth();
		console.log(path, parent);
		const response = await db.fetch(`files/move/`,  {
			method: 'POST',
			body: JSON.stringify({path, parent})
		});
		const output = await response.json()
		output.filter(x => x.error).forEach(error => commit('addError', error));
		await dispatch('getFiles');
		commit('setLoading', false);
	},
	async downloadFile({commit}, path) {
		commit('setLoading', true);
		const db = new Auth();
		const query = new URLSearchParams({path});
		const response = await db.fetch(`files/download/?${query}`);
		if (response.status === 404) {
			commit('addError', {error: 'File not found'});
			return;
		}
		
		const contentDisposition = response.headers.get('content-disposition');
		const filenameMatch = contentDisposition?.match(/filename\*=UTF-8''([^;\n]+)/i)
			?? contentDisposition?.match(/filename="([^"]+)"/i);
		const filename = filenameMatch ? decodeURIComponent(filenameMatch[1]) : String(path).split('/').pop();

		const blob = await response.blob();
		const link = document.createElement('a');
		link.href = window.URL.createObjectURL(blob);
		link.download = filename;
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
		commit('setLoading', false);
	}	
};

const mutations = {
	setFiles(state, files){
		state.files = files;
	},
	setFile(state, file){
		state.file = file;
	},
	addError(state, error){
		state.errors.push(error);
	},
	setFileTypes(state, fileTypes){
		state.fileTypes = fileTypes;
	},
	setLoading(state, loading){
		state.loading = loading;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
